import React, { useState, useEffect, useRef } from 'react';
import TextEditor from "../../elements/TextEditor";
import SuggestionBar from "../../elements/SuggestionBar";
import ToolBar from "../../elements/ToolBar";
import UnderlineResult from "../../elements/TextEditor/UnderlineResult";
import "./textEditorPage.css";
import axios from "axios";
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from "react-i18next";

const client = new WebSocket('wss://backend2.senarai-app.com/analyze-websocket');


const TextEditorPage = ({isProductDemo}) => {
  const [evaluation, setEvaluation] = useState([]);
  const [editedWords, setEditedWords] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const notifyError = (message) => toast.error(message,  { className: 'toast-error' });
  const { t } = useTranslation();

  /**
   * Ref to the editor component
   * @type {React.MutableRefObject<import("@tiptap/react").Editor>}
   */
  const editorRef = useRef(null);
  const jwtToken = localStorage.getItem('token');

  useEffect(() => {
    if (!jwtToken && !isProductDemo) {
      window.location.href = '/product-demo';
    }
    if (jwtToken && isProductDemo) {
      window.location.href = '/product';
    }
    if (jwtToken) {
      onLoad();
    }
  }, [jwtToken, isProductDemo]);

  const handleAnalysisWebsocket = async (text) => {
    if (client.readyState !== client.OPEN) return;
    client.send(text);
  };

  useEffect(() => {
    client.onopen = () => {
      console.log("Websocket Client Connected");
    };
    client.onmessage = (response) => {
      console.log("terkirim")
      let returnedData = JSON.parse(response.data); // to string
      returnedData = JSON.parse(returnedData); // to object (array)
      setEvaluation(returnedData.filter(
        (data) => !editedWords.includes(data.originalWord)
      ));
    };
    client.onerror = (error) => {
      notifyError(error)
    };
    client.onclose = () => {
      notifyError("Websocket Client Disconnected")
    };
  }, [editedWords]);


  useEffect(() => {
    console.log("Editor ref:", editorRef.current);
    if (!editorRef.current) return;

    let timeout = null;

    console.log("Update event added");

    editorRef.current.on("update", () => {

      console.log("Update event fired");
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        onSave();
        // Get the title of page and set it to Saved! for a few seconds
        console.log("Saved!");
      }, 3000);
    });

    return () => {
      if (!editorRef.current) return;
      editorRef.current.off("update");

      if (!timeout) return;
      clearTimeout(timeout);
    }
  }, [editorRef, editorRef.current]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const removeMessage = (item, decline) => {
    const filt = evaluation.filter((i) => !item.includes(i));
    setEvaluation(filt);
    if(decline){ 
     setEditedWords((prevEditedWords) => [...prevEditedWords, item[0].originalWord]);
    }
  };


  const onLoad = async () => {
    // Check if id is present on the URL
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');

    // Disable fetching document data for now
    if (id) {
      try {
        // Get document and set the content to the editor
        const response = await axios.get(`https://backend2.senarai-app.com/document/${id}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtToken}`
          }
        })
        if (!response) {
          throw new Error("Failed to fetch document data");
        }
        const { content } = response.data;
        if (!editorRef.current) return;
        editorRef.current.commands.setContent(content);
      } catch (error) {
        notifyError(error.message);
      }
    }
  }

  const onSave = async () => {
    if (!editorRef.current) return;
    const text = editorRef.current.getText();

    // Get ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');

    // If ID is present, update the document
    if (id) {
      try {
        const response = await axios.put(`https://backend2.senarai-app.com/update-document/${id}`, {
          content: text
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtToken}`
          }
        })
        console.log(response.data);
      } catch (error) {
        if (error?.response?.data) {
          notifyError(error.response.data.detail);
        } else {
          notifyError(`Error updating document data: ${error.message}`);
        }
      }
      return;
    }
  }


  document.body.style.overflow='hidden'

  return (
    <div className="body">
      <ToastContainer position="bottom-center" />
      {!isDrawerOpen ? (
        <div data-testid="toolbar-button-show" className="show-toolbar" onClick={toggleDrawer}>
          <p>{t("show_toolbar")}</p>
        </div>
      ) : (
        <div data-testid="toolbar-button-hide" className="hide-toolbar" onClick={toggleDrawer}>
          <p>{t("hide_toolbar")}</p>
        </div>
      )}

      {jwtToken !== null ? (
        <div className="z-1" data-testid="toolbar-loggedin">
          <ToolBar drawerState={isDrawerOpen} isLogin={true}/>
        </div>
      ) : (
        <div className="z-1" data-testid="toolbar-loggedout">
          <ToolBar drawerState={isDrawerOpen} isLogin={false} />
        </div>
      )}
      <div className="textEditor">
        <TextEditor 
          onAnalyze={handleAnalysisWebsocket} 
          editorRef={editorRef} 
          isProductDemo={isProductDemo}
        />
        {editorRef.current && evaluation && (
          <UnderlineResult editor={editorRef.current} result={evaluation} />
        )}
      </div>
      <SuggestionBar
        className="suggestion-bar"
        words={evaluation}
        editorRef={editorRef}
        webSocket={handleAnalysisWebsocket}
        onRemove={removeMessage}
      />
    </div>
  );
};


TextEditorPage.propTypes = {
  isProductDemo: PropTypes.bool
};

export default TextEditorPage;
